import { render } from "./Table.vue?vue&type=template&id=ddbf3f38&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import "./Table.vue?vue&type=style&index=0&id=ddbf3f38&scoped=true&lang=css"

import exportComponent from "/Users/walt/WORK/school/portfolio/s1-crypto-prng/prng/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddbf3f38"]])

export default __exports__